export default __webpack_public_path__ + "static/media/logo-dark.bf1d2975.png";